import { render, staticRenderFns } from "./EquipmentInfo.vue?vue&type=template&id=06ff3727&scoped=true&"
import script from "./EquipmentInfo.vue?vue&type=script&lang=js&"
export * from "./EquipmentInfo.vue?vue&type=script&lang=js&"
import style0 from "./EquipmentInfo.vue?vue&type=style&index=0&id=06ff3727&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ff3727",
  null
  
)

export default component.exports